import React from "react";
import styled from "styled-components";

const StyledDescription = styled.div`
  color: ${({ theme }) => theme.colors.darkgrey};
  font: normal normal normal 18px/22px Open Sans;
`;

export default function Description() {
  return (
    <StyledDescription>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ipsum,
      ullamcorper sit amet tortor sit amet, tincidunt finibus ex. Curabitur
      aliquam ligula vitae.
    </StyledDescription>
  );
}
